module.exports = __webpack_public_path__ + "bin/be20c458c3ffeb01ce462ad1718d73c8.jpg";